import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAccountCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	viewBox: "0 0 28 28",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 14,
		cy: 14,
		r: 14,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M18.126 23h-1.54c.025 0 .618-.542.618-1.2V11.662h4.616-.73 1.904v1.33h-.537v8.786c0 .672-.612 1.222-1.367 1.222h-.34a.661.661 0 0 0 0-.047v-2.657a.666.666 0 0 0-.665-.666H18.79a.666.666 0 0 0-.666.666v2.657l.001.047Zm-5.91-.046v-2.658a.666.666 0 0 0-.667-.666h-1.294a.666.666 0 0 0-.666.666v2.658H7.012a1.332 1.332 0 0 1-1.332-1.33L5.65 6.33h-.644V5h11.819v1.33h-.67v15.457c0 .659-.526 1.167-1.138 1.167h-2.802ZM7.628 8.324a.666.666 0 0 0-.667.667v1.993c0 .367.299.666.667.666h1.95a.666.666 0 0 0 .666-.666V8.99a.666.666 0 0 0-.666-.666H7.63Zm0 5.32a.666.666 0 0 0-.667.667v1.992c0 .368.299.667.667.667h1.95a.666.666 0 0 0 .666-.667v-1.992a.666.666 0 0 0-.666-.666H7.63Zm4.596-5.32a.666.666 0 0 0-.666.667v1.993c0 .367.298.666.666.666h1.95a.666.666 0 0 0 .666-.666V8.99a.666.666 0 0 0-.666-.666h-1.95Zm0 5.32a.666.666 0 0 0-.666.667v1.992c0 .368.298.667.666.667h1.95a.666.666 0 0 0 .666-.667v-1.992a.666.666 0 0 0-.666-.666h-1.95Z"
	})]
});
export default SvgIconAccountCircle;
